/**
 * Product Endpoints
 */

export const apiPostProduct = async (
  product: ProductCreateUpdate,
): Promise<AxiosResponse<Product>> => {
  return await userManagementAxiosInstance.post('products', product);
};

export const apiGetProducts = async (
  limit: number = defaultLimit,
  offset: number = defaultOffset,
  sku_str: string = '',
  search: string = '',
  lifecycle_stage: string = '',
): Promise<AxiosResponse<PaginatedProduct>> => {
  return await userManagementAxiosInstance.get(
    `products?limit=${limit}&offset=${offset}&sku_str=${sku_str}&name=${search}&lifecycle_stage=${lifecycle_stage}`,
  );
};

export const apiGetProduct = async (id: string | number): Promise<AxiosResponse<Product>> => {
  return await userManagementAxiosInstance.get(`products/id/${id}`);
};

export const apiPutProduct = async (
  product: ProductCreateUpdate,
): Promise<AxiosResponse<Product>> => {
  return await userManagementAxiosInstance.put(`products/id/${product.id}`, product);
};

export const apiDeleteProduct = async (id: string | number): Promise<AxiosResponse<Product>> => {
  return await userManagementAxiosInstance.delete(`products/id/${id}`);
};
